export const seatingPreferenceOptions = {
  SELL_SEAT_MAP_SEGMENT_NEW: 'SellSeatMapSegmentNew',
  SELL_SEATING_BESIDE: 'SellSeatingBeside',
  SELL_SEATING_PREFERENCE: 'SellSeatingPreference'
};
//# sourceMappingURL=seatingPreferenceOptions.js.map